import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useTranslation } from "react-i18next";

export function ConfirmUnbindLink({
  trigger,
  type,
  onConfirm,
}: {
  trigger: React.ReactNode;
  type: "SMS" | "Telegram" | "Whatsapp";
  onConfirm: () => void;
}) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleDialogClose = (isOpen: boolean) => {
    setIsOpen(isOpen);
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleDialogClose} modal={false}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>

      {isOpen && (
        <div className="fixed inset-0 bg-black/10 backdrop-blur-[4px] z-40 pointer-events-none"></div>
      )}
      <DialogContent
        className="max-h-full overflow-auto gap-4 pb-[40px]"
        onInteractOutside={(e) => {
          e.preventDefault();
        }}
      >
        <DialogHeader className="mb-[16px]">
          <DialogTitle className="flex flex-col gap-6 items-center font-medium">
            <div className="border-[3px] text-[25px] border-[#FF0000] text-[#FF0000] rounded-full w-[48px] h-[48px] flex items-center justify-center">
              !
            </div>

            <div className="flex-1 flex flex-col gap-4 justify-center items-center">
              <span className="text-[24px] leading-[32px] whitespace-pre-line">
                {t("ConfirmUnbindLink.title")}
                {" "}
                {type}?
              </span>
              <span className="text-[18px] leading-[24px] text-[#00000080] whitespace-pre-line">
                {t("ConfirmUnbindLink.description")}
                {" "}
                {type}
              </span>
            </div>
            <div className="flex flex-row gap-4">
              <Button
                variant="outline"
                className="w-fit h-[60px] text-[24px]"
                onClick={() => setIsOpen(false)}
              >
                {t("ConfirmUnbindLink.cancel")}
              </Button>
              <Button
                type="submit"
                variant="system"
                size="system"
                className="w-fit px-4 "
                onClick={onConfirm}
              >
                {t("ConfirmUnbindLink.confirm")}
              </Button>
            </div>
          </DialogTitle>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
